import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import {
  Box,
  Avatar,
  Typography,
  IconButton,
  AppBar,
  Toolbar,
  Container,
  Card,
  CardContent,
  Divider,
} from "@mui/material";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import EditIcon from "@mui/icons-material/Edit";
import { BASE_URL } from "./../../Api/ApiUrls";
import FormsBottomNavbar from "./../Post Module/FormsBottomNavbar";

const UserProfile = () => {
  const { userId } = useParams();
  const navigate = useNavigate();
  const [userData, setUserData] = useState(null);

  useEffect(() => {
    if (!userId) return;

    fetch(`${BASE_URL}/users/${userId}/`)
      .then((response) => response.json())
      .then((data) => {
        setUserData(data);
      })
      .catch((error) => console.error("Error fetching user data:", error));
  }, [userId]);

  return (
    <Box sx={{ 
      display: 'flex',
      flexDirection: 'column',
      minHeight: '100vh',
      background: `
        linear-gradient(145deg, rgba(232,224,208,0.95), rgba(216,204,186,0.95)),
        url('https://www.transparenttextures.com/patterns/cream-paper.png')
      `,
      backgroundSize: 'cover',
      backgroundAttachment: 'fixed'
    }}>
      {/* Header */}
      <AppBar 
        position="static" 
        elevation={0}
        sx={{ 
          background: `
            linear-gradient(145deg,rgb(22, 22, 22),rgb(15, 15, 15)),
            url('https://www.transparenttextures.com/patterns/dark-matter.png')
          `,
          color: 'text.primary',
          boxShadow: '0 2px 10px rgba(0,0,0,0.1)'
        }}
      >
        <Toolbar sx={{ minHeight: 64 }}>
          <IconButton 
            edge="start" 
            onClick={() => navigate(-1)}
            sx={{ 
              color: '#ffffff',
              backgroundColor: 'rgba(255,255,255,0.1)',
              '&:hover': { 
                backgroundColor: 'rgba(255,255,255,0.2)' 
              }
            }}
          >
            <ArrowBackIosNewIcon />
          </IconButton>
          <Typography variant="h6" sx={{ flexGrow: 1, ml: 2, color: 'white' }}>
            Profile Details
          </Typography>
        </Toolbar>
      </AppBar>

      {/* Profile Content */}
      <Container sx={{ py: 3, flex: 1 }}>
  <Card sx={{ borderRadius: '12px', overflow: 'hidden', boxShadow: 3, position: 'relative' }}>
    {/* Edit Icon Button positioned at top-right */}
    <IconButton
      onClick={() => navigate(`/edit-profile`)}
      sx={{
        position: 'absolute',
        top: 8,
        right: 8,
        backgroundColor: 'rgba(0, 0, 0, 0.04)',
        '&:hover': {
          backgroundColor: 'rgba(0, 0, 0, 0.08)',
        },
        zIndex: 1
      }}
    >
      <EditIcon />
    </IconButton>

    <CardContent>
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', p: 3 }}>
        <Avatar
          alt={userData?.username || "User"}
        //   src={
        //     userData?.profile
        //       ? `${BASE_URL}${userData.profile}`
        //       : "https://randomuser.me/api/portraits/women/44.jpg"
        //   }
        src={userData?.profile ? `${BASE_URL}${userData.profile}` : ""}
          sx={{
            width: 120,
            height: 120,
            mb: 3,
            border: '4px solid white',
            boxShadow: 3
          }}
        />
        
        <Typography variant="h5" sx={{ fontWeight: 'bold', mb: 1 }}>
          {userData?.username || "Loading..."}
        </Typography>
        
        <Typography variant="body2" sx={{ color: 'text.secondary', mb: 3 }}>
          {userData?.email || "Loading..."}
        </Typography>
      </Box>

      <Divider sx={{ my: 2 }} />

      <Box sx={{ p: 2 }}>
        {[
          { label: 'Customer ID', value: userData?.user_id ? `CUSTOMER${userData.user_id.toString().padStart(4, '0')}` : "Loading..." },
          { label: 'Mobile Number', value: userData?.mobile_no || "Not provided" },
          { label: 'City', value: userData?.city || "Not provided" },
          { label: 'State', value: userData?.state || "Not provided" },
        ].map((item, index) => (
          <Box key={index} sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
            <Typography variant="body1" sx={{ fontWeight: 'bold' }}>
              {item.label}:
            </Typography>
            <Typography variant="body1">
              {item.value}
            </Typography>
          </Box>
        ))}
      </Box>
    </CardContent>
  </Card>
</Container>
       <Box sx={{ position: "fixed", bottom: 0, left: 0, right: 0 }}>
              <FormsBottomNavbar />
            </Box>
    </Box>
  );
};

export default UserProfile;